import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';


@Pipe({name: 'convertUTCToTZ'})
export class ConvertUTCToTZPipe implements PipeTransform {
  transform(dateUTC: string, timezone: any = moment.tz.guess(), formatStr: string = 'YYYY-MM-DD HH:mm:ss'): any {
    if (!dateUTC) { return null; }

    try {
      const currDate = moment.tz(dateUTC, 'UTC');
      if (currDate) {
        return currDate.tz(timezone).format(formatStr);
      } else {
        return dateUTC;
      }
    } catch (e) {
      return dateUTC;
    }
  }
}
